import React from 'react';
import { VolumeCapsuleData } from 'widgets/liquiditySummary/volumeCapsule/components/volumeCapsuleData';

import './VolumeCapsuleChartAdvLabel.scss';
import measureText from 'utils/text/measureText';
import { scaleLinear } from 'd3-scale';
import { styleConstants } from 'widgets/tiles/components/styles/variables.module.constants';

export interface VolumeCapsuleChartAdvLabelProps {
    data: VolumeCapsuleData;
}

export function VolumeCapsuleChartAdvLabel(
    props: VolumeCapsuleChartAdvLabelProps
) {
    const { data } = props;
    const { todayAdvPercent, todayTotal } = data;
    const { tileWidth } = styleConstants;

    const scale = scaleLinear();
    scale.domain([0, data.maxX]).range([0, tileWidth]);
    const totalX = scale(todayTotal);

    const label = `${todayAdvPercent}% of ADV`;

    const textWidth = measureText(label);
    let left = totalX - textWidth / 2;
    if (left + textWidth > tileWidth) {
        left = tileWidth - textWidth;
    }
    if (left < 0) {
        left = 0;
    }

    const style = { left };
    return (
        <div className="VolumeCapsuleChartAdvLabel" style={style}>
            {label}
        </div>
    );
}
